import {Thanks} from '../containers/Thanks/index';

export const ConfirmRegister = () => (
    <Thanks/>
)